// The native app loads each WebView with ?mobile=true. The param is only
// present on the initial URL (SPA navigations drop it), so capture it once
// at module load.
const isMobileView =
  new URLSearchParams(globalThis.location?.search ?? '').get('mobile') ===
  'true';

export function isMobileWebView() {
  return isMobileView;
}

// Ask the native app to navigate to one of its own screens instead of
// navigating inside the WebView. The app maps the web route to a native one.
export function postMobileNavigate(route) {
  globalThis.ReactNativeWebView?.postMessage(
    JSON.stringify({ type: 'NAVIGATE', route })
  );
}

// Ask the native app to open a URL in the device browser (outside the app).
export function postMobileOpenUrl(url) {
  globalThis.ReactNativeWebView?.postMessage(
    JSON.stringify({ type: 'OPEN_URL', url })
  );
}

// Ask the native app to switch the "view as" context to another agent.
export function postMobileViewAsAgent(agentId) {
  globalThis.ReactNativeWebView?.postMessage(
    JSON.stringify({ type: 'VIEW_AS_AGENT', agentId })
  );
}

// Ask the native app to save/share a CSV file instead of doing a browser download.
export function postMobileDownloadCsv(csvData, filename) {
  globalThis.ReactNativeWebView?.postMessage(
    JSON.stringify({ type: 'DOWNLOAD_CSV', csvData, filename })
  );
}
